import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';


const LazyCreatePortfolio = lazy(() => import('./CreatePortfolio'));

export const CreatePortfolio: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<LazyCreatePortfolio {...props} />
	</Suspense>
);
